module.exports = __webpack_public_path__ + "static/media/grin-squint-tears.2f02b90a.svg";